/* eslint-disable no-var */
/* eslint-disable no-unused-vars */
import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { SectionHeadingMed } from '../../Headings';
import closeIconLarge from '../../../assets/images/svg/close-icon-large.svg';
import './cancelModal.css';

function CancelModal(props) {
  const { show, close } = props;

  return (
    <Modal
      show={show}
      className="modalLayout closeModal"
      onHide={close}
      centered
      aria-labelledby="containoded-mal-title-vcenter"
    >
      <Modal.Body>
        <div className="content">
          <img src={closeIconLarge} alt="closeIconLarge" />
          <SectionHeadingMed text="Are you sure you want to delete this medical record?" />
          <div className="btnsContainer">
            <button
              type="button"
              onClick={close}
              className="simple_btn success"
            >
              NO, GO BACK
            </button>
            <button type="button" className="simple_btn warning">
              YES
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default CancelModal;
